import React, { Component, Fragment } from "react";
import WriteMissingWordsContainerUI from "./WriteMissingWordsContainerUI";
class WriteMissingWordsActivityUI extends Component {
    render = () => {
        let { activity, quizViewer } = this.props;
        return (
            <Fragment>
                <WriteMissingWordsContainerUI activity={activity} quizViewer={quizViewer} />
            </Fragment>
        );
    }
}
export default WriteMissingWordsActivityUI;
